// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoginForm } from '../../components/LoginForm';

const getRedirectTarget = (search: string): string | null => {
  const params = new URLSearchParams(search);
  const redirectUri = params.get('redirectUri');
  if (!redirectUri) {
    return null;
  }
  try {
    const parsed = new URL(redirectUri, window.location.origin);
    if (parsed.origin !== window.location.origin) {
      return null;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
};

const LoginPage = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const redirectTarget = getRedirectTarget(location.search);

  const handleLoginSuccess = useCallback((): void => {
    if (redirectTarget) {
      navigate(redirectTarget);
      return;
    }
    navigate('/app/v2');
  }, [navigate, redirectTarget]);

  return <LoginForm onLogin={handleLoginSuccess} />;
};

export default LoginPage;
